import React from 'react'

interface PasswordStrengthBarProps {
  password: string
}

/** Şifre gücünü hesapla: 0 = boş, 1 = zayıf, 2 = orta, 3 = güçlü */
function getStrength(password: string): { level: number; label: string; color: string } {
  if (!password) return { level: 0, label: '', color: '' }

  let score = 0
  if (password.length >= 8) score++
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score++
  if (/\d/.test(password)) score++
  if (/[^a-zA-Z0-9]/.test(password)) score++

  if (score <= 1) return { level: 1, label: 'Zayıf', color: '#EF4444' }
  if (score <= 2) return { level: 2, label: 'Orta', color: '#F59E0B' }
  return { level: 3, label: 'Güçlü', color: '#22C55E' }
}

export function PasswordStrengthBar({ password }: PasswordStrengthBarProps) {
  const { level, label, color } = getStrength(password)
  if (!password) return null

  return (
    <div className="mt-2 space-y-1">
      {/* Progress Bars */}
      <div className="flex gap-1.5">
        {[1, 2, 3].map(i => (
          <div
            key={i}
            className="h-1 flex-1 rounded-full transition-all duration-300"
            style={{
              backgroundColor: i <= level ? color : '#E5E7EB',
            }}
          />
        ))}
      </div>
      {/* Label */}
      <p
        className="text-[10px] font-bold text-right transition-colors duration-300"
        style={{ color }}
      >
        {label}
      </p>
    </div>
  )
}
